import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { chatServiceApi } from "../../services/chatServiceApi";

// ✅ Thunk lấy tin nhắn từ API
export const fetchMessages = createAsyncThunk(
  "messages/fetchMessages",
  async (chatRoomId, { rejectWithValue }) => {
    try {
      const data = await chatServiceApi.getMessage(chatRoomId);
      return data; // Danh sách tin nhắn
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error fetching messages");
    }
  }
);

// const messagesSlice = createSlice({
//   name: "messages",
//   initialState: [],
//   reducers: {
//     addMessage: (state, action) => {
//       state.push(action.payload);
//     },
//     setMessages: (state, action) => {
//       return action.payload;
//     },
//   },
//   extraReducers: (builder) => {
//     builder.addCase(fetchMessages.fulfilled, (state, action) => {
//       return action.payload; // Gán danh sách tin nhắn từ API
//     });
//   },
// });

const messagesSlice = createSlice({
  name: "messages",
  initialState: {
    messages: [],
    searchTerm: "",
  },
  reducers: {
    addMessage: (state, action) => {
      state.messages.push(action.payload);
    },
    setMessages: (state, action) => {
      state.messages = action.payload;
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchMessages.fulfilled, (state, action) => {
      state.messages = action.payload;
    });
  },
});

export const { addMessage, setMessages, setSearchTerm } = messagesSlice.actions;
export default messagesSlice.reducer;
